import Box from "ds/components/Box";
import EnableAiFeatures from "views/Account/Settings/AI/EnableAiFeatures";

import styles from "./styles.module.css";

const AssistantPanelChatTermsOverlay = () => {
  return (
    <Box className={styles.overlay} direction="column" justify="end" align="center">
      <EnableAiFeatures
        heading="Enable Infra Assistant for your organization"
        description="Infra Assistant is powered by Spacelift Intelligence. It helps with Terraform, OpenTofu, and stack management."
        buttonLabel="Enable Infra Assistant"
      />
    </Box>
  );
};

export default AssistantPanelChatTermsOverlay;
